import { Component, input } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { AppTitleComponent } from "../app-title/app-title.component";
import { HeaderDowntimeComponent } from "../header-downtime/header-downtime.component";
import { HelpComponent } from "../help/help.component";
import { LogoComponent } from "../logo/logo.component";
import { PreferencesComponent } from "../preferences/preferences.component";
import { UserInfoComponent } from "../user-info/user-info.component";


@Component({
  selector: 'app-header',
  imports: [LogoComponent, AppTitleComponent, UserInfoComponent, PreferencesComponent, ToolbarModule, HelpComponent, HeaderDowntimeComponent],
  templateUrl: './header.component.html',
  styles: `
    :host ::ng-deep .p-toolbar {
      background-image: url('/header-background_light.jpg');
      background-size: cover;
    }
    :host-context(.qh-dark) ::ng-deep .p-toolbar {
      background-image: url('/header-background_dark.png');
      background-size: cover;
    }
  `
})
export class HeaderComponent {

  authenticated = input()

  constructor() {}

}
